var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rexer_event-contact" }, [
    _c("a", { attrs: { href: _vm.renderHref, title: "", target: "_blank" } }, [
      _c("span", {
        staticClass: "rexer_event-contact__icon",
        domProps: { innerHTML: _vm._s(_vm.renderIcon) }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "rexer_event-contact__name" }, [
        _vm._v("\n      " + _vm._s(_vm.text) + "\n    ")
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }